import { render } from "./SiteMap.vue?vue&type=template&id=9fcd85ae&scoped=true"
import script from "./SiteMap.vue?vue&type=script&lang=js"
export * from "./SiteMap.vue?vue&type=script&lang=js"

import "./SiteMap.vue?vue&type=style&index=0&id=9fcd85ae&scoped=true&lang=css"

import exportComponent from "D:\\tinygeeker.com\\perfectSitemap\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fcd85ae"]])

export default __exports__